import { render, staticRenderFns } from "./SectionReportsNav.vue?vue&type=template&id=1b239346&scoped=true"
import script from "./SectionReportsNav.vue?vue&type=script&lang=js"
export * from "./SectionReportsNav.vue?vue&type=script&lang=js"
import style0 from "./SectionReportsNav.vue?vue&type=style&index=0&id=1b239346&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b239346",
  null
  
)

export default component.exports